import { Component } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'manjocarn';

  constructor(viewportScroller: ViewportScroller) {
    // Compense la hauteur de la nav sticky : le scroll vers une ancre (Router)
    // n'honore pas le scroll-margin-top CSS, contrairement au saut natif du navigateur.
    viewportScroller.setOffset([0, 72]);
  }
}
